import RecordClassCreator from "services/record";

export default class StatsAnswersPerformanceRecord extends RecordClassCreator({
  type: "statsAnswersPerformanceRecord",

  /** @memberof StatsAnswersPerformanceRecord# */
  answerId: undefined,

  /** @memberof StatsAnswersPerformanceRecord# */
  count: undefined,

  /** @memberof StatsAnswersPerformanceRecord# */
  negReviews: undefined,

  /** @memberof StatsAnswersPerformanceRecord# */
  posReviews: undefined,

  /** @memberof StatsAnswersPerformanceRecord# */
  answerName: undefined
}) {
  /**
   * @param {Immutable.List.<Response>} allResponses
   * @returns {Response|null}
   */
  getResponse(allResponses) {
    return allResponses.find(response => response.id === this.answerId) || null;
  }

  /**
   * @returns {Number}
   */
  get totalReviews() {
    return this.posReviews + this.negReviews;
  }

  /**
   * @returns {Number|null}
   */
  get satisfactionRatio() {
    const { totalReviews } = this;

    return totalReviews ? this.posReviews / totalReviews : null;
  }
}
